import { render, staticRenderFns } from "./ProductChangeSelection.vue?vue&type=template&id=6145add1"
import script from "./ProductChangeSelection.vue?vue&type=script&lang=js"
export * from "./ProductChangeSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports